/* Cânon Nissi — WhatsApp no Cart Drawer (tag: encomendar)

  Ajuste solicitado:
  - Se houver qualquer item com tag "encomendar" no carrinho, o botão "Finalizar compra" do CART DRAWER
    deve virar "FALAR NO WHATSAPP" e enviar a lista de itens.
  - Se não houver encomenda, o botão volta ao comportamento normal (checkout).

  Nota técnica importante:
  - /cart.js não expõe tags. Por isso, este script consulta /products/<handle>.js para obter tags.
  - O script é global porque o drawer aparece em qualquer template.
*/
(function(){
  if(window.__CN_DRAWER_WA_BOOTED) return;
  window.__CN_DRAWER_WA_BOOTED = true;

  var PHONE = '351913767399';
  var BTN_TEXT_WA = 'ENCOMENDAR AGORA';

  function q(sel, root){ return (root||document).querySelector(sel); }

  function getCartJSON(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); });
  }

  // Cache de tags por handle
  var tagCache = {};
  function getProductTags(handle){
    if(!handle) return Promise.resolve([]);
    if(tagCache[handle]) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(p){
        var tags = (p && p.tags) ? p.tags : [];
        tagCache[handle] = tags;
        return tags;
      })
      .catch(function(){ tagCache[handle] = []; return []; });
  }

  function deriveCartTags(cart){
    var items = (cart && cart.items) ? cart.items : [];
    return Promise.all(items.map(function(it){
      return getProductTags(it.handle).then(function(tags){
        var lower = (tags||[]).map(function(t){ return String(t||'').toLowerCase().trim(); });
        return {
          title: it.title,
          product_title: it.product_title,
          variant_title: it.variant_title,
          sku: it.sku,
          price: it.price,
          final_line_price: it.final_line_price,
          quantity: it.quantity,
          handle: it.handle,
          isEncomendar: lower.indexOf('encomendar') !== -1
        };
      });
    })).then(function(list){
      var hasEnco = list.some(function(x){ return x.isEncomendar; });
      var hasAvailable = list.some(function(x){ return !x.isEncomendar; });
      return {
        items: list,
        hasEnco: hasEnco,
        isMixed: hasEnco && hasAvailable
      };
    });
  }

  function buildWhatsHref(items, mode){
    var lines = (items||[]).map(function(it){
      return '• ' + (it.title||'Produto') + ' x' + (it.quantity||1);
    }).join('%0A');

    if(mode === 'mixed'){
      return 'https://wa.me/' + PHONE + '?text=' +
        'Ol%C3%A1!%20Adicionei%20estes%20produtos%20ao%20carrinho:%0A' + lines +
        '%0AH%C3%A1%20itens%20com%20prazos%20diferentes%20no%20carrinho.%20Pode%20ajudar-me%20a%20finalizar%20corretamente%3F';
    }

    return 'https://wa.me/' + PHONE + '?text=' +
      'Ol%C3%A1!%20Gostaria%20de%20encomendar%20estes%20produtos:%0A' + lines +
      '%0AEstes%20itens%20s%C3%A3o%20feitos%20por%20encomenda%20e%20podem%20ter%20prazo%20maior.%20Pode%20ajudar-me%20a%20finalizar%3F';
  }

  // === Modal helpers (usa o snippet cn-whatsapp-mixed-modal.liquid) ===
  function openMixed(items){
    var ov = q('#cn-whatsapp-mixed-overlay');
    if(!ov) return false;
    var box = q('#cnw-items');
    if(box){
      var ul = document.createElement('ul');
      (items||[]).forEach(function(it){
        var li = document.createElement('li');
        li.textContent = (it.title||'Produto') + ' x' + (it.quantity||1);
        ul.appendChild(li);
      });
      box.innerHTML = '';
      box.appendChild(ul);
    }
    var wa = q('#cnw-whatsapp');
    if(wa){ wa.href = buildWhatsHref(items, 'mixed'); }
    ov.classList.add('cnw-open');
    document.body.classList.add('cnw-modal-open'); document.documentElement.classList.add('cnw-modal-open');
    return true;
  }

  function openEncomendar(items){
    var ov = q('#cn-encomendar-overlay');
    if(!ov) return false;
    try { if(ov.parentNode !== document.body) document.body.appendChild(ov); } catch(e){}

    var currentItems = items || [];

    var box = q('#cne-items', ov);
    if(box){
      var ul = document.createElement('ul');
      currentItems.forEach(function(it){
        var li = document.createElement('li');
        li.textContent = (it.title||'Produto') + ' x' + (it.quantity||1);
        ul.appendChild(li);
      });
      box.innerHTML = '';
      box.appendChild(ul);
    }

    var form     = q('#cne-form', ov);
    var introPs  = ov.querySelectorAll('.cnw-body > p');
    var itemsBox = q('#cne-items', ov);
    var footer   = ov.querySelector('.cnw-footer');
    var btnWA    = q('#cne-whatsapp', ov);
    var btnBack  = q('#cne-form-back', ov);
    var titleEl  = q('#cne-title', ov);

    function showInitial(){
      if(form) form.hidden = true;
      introPs.forEach(function(p){ p.style.display = ''; });
      if(itemsBox) itemsBox.style.display = '';
      if(footer) footer.style.display = '';
      if(titleEl) titleEl.textContent = 'Produto temporariamente esgotado!';
    }
    function showForm(){
      introPs.forEach(function(p){ p.style.display = 'none'; });
      if(itemsBox) itemsBox.style.display = 'none';
      if(footer) footer.style.display = 'none';
      if(titleEl) titleEl.textContent = 'Dados para a encomenda';
      if(form) form.hidden = false;
    }
    showInitial();
    if(form) form.reset();

    if(btnWA){ btnWA.onclick = function(ev){ ev.preventDefault(); ev.stopPropagation(); showForm(); }; }
    if(btnBack){ btnBack.onclick = function(ev){ ev.preventDefault(); ev.stopPropagation(); showInitial(); }; }

    if(form){
      form.onsubmit = function(ev){
        ev.preventDefault();
        if(typeof form.checkValidity === 'function' && !form.checkValidity()){
          if(typeof form.reportValidity === 'function') form.reportValidity();
          return false;
        }
        var fd = new FormData(form);
        function v(n){ return String(fd.get(n) || '').trim(); }
        function fmtEur(c){ if(c == null || isNaN(c)) return ''; return '€' + (Number(c)/100).toFixed(2).replace('.', ','); }
        var totalCents = 0;
        var lines = currentItems.map(function(it){
          var name = it.product_title || it.title || 'Produto';
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
          var qty = it.quantity || 1;
          var unit = fmtEur(it.price);
          var sub  = fmtEur(it.final_line_price != null ? it.final_line_price : (it.price||0)*qty);
          if(it.final_line_price != null) totalCents += Number(it.final_line_price);
          else if(it.price != null) totalCents += Number(it.price) * qty;
          var l = '• ' + name;
          if(variant) l += '\n   - Variante: ' + variant;
          if(it.sku) l += '\n   - SKU: ' + it.sku;
          l += '\n   - Qtd: ' + qty + (unit ? ' × ' + unit : '') + (sub ? ' = ' + sub : '');
          return l;
        }).join('\n');
        var totalLine = totalCents > 0 ? ('\nTotal: ' + fmtEur(totalCents)) : '';
        var msg =
          'Olá! Gostaria de encomendar:\n' + lines + totalLine + '\n\n' +
          'Dados para encomenda:\n' +
          'Nome: ' + v('nome') + '\n' +
          'Telefone: ' + v('telefone') + '\n' +
          'E-mail: ' + v('email') + '\n' +
          'NIF: ' + v('nif') + '\n' +
          'Morada: ' + v('morada') + '\n' +
          'Código Postal: ' + v('cp') + '\n' +
          'Freguesia: ' + v('freguesia') + '\n' +
          'Distrito: ' + v('distrito');
        var href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(msg);
        try { window.open(href, '_blank', 'noopener'); }
        catch(e){ window.location.href = href; }
        closeModal();
        return false;
      };
    }

    function closeModal(){
      ov.classList.remove('cnw-open');
      document.body.classList.remove('cnw-modal-open'); document.documentElement.classList.remove('cnw-modal-open');
      showInitial();
      if(form) form.reset();
    }
    var btnClose = q('.cne-close', ov);
    if(btnClose){ btnClose.onclick = function(ev){ ev.preventDefault(); ev.stopPropagation(); closeModal(); }; }
    var cont = q('#cne-continue', ov);
    if(cont){ cont.onclick = function(ev){ ev.preventDefault(); ev.stopPropagation(); closeModal(); }; }
    ov.onclick = function(e){ if(e.target === ov) closeModal(); };

    ov.classList.add('cnw-open');
    document.body.classList.add('cnw-modal-open'); document.documentElement.classList.add('cnw-modal-open');
    return true;
  }

  function closeAnyModal(){
    try{ var a=q('#cn-whatsapp-mixed-overlay'); if(a) a.classList.remove('cnw-open'); }catch(e){}
    try{ var b=q('#cn-encomendar-overlay'); if(b) b.classList.remove('cnw-open'); }catch(e){}
    try{ document.body.classList.remove('cnw-modal-open'); document.documentElement.classList.remove('cnw-modal-open'); }catch(e){}
  }

  // === Drawer button replacement ===
  function findDrawerCheckoutButton(){
    return q('#CartDrawer-Checkout') || q('button[name="checkout"][form="CartDrawer-Form"]');
  }

  // Em vez de reutilizar o botão de checkout (que pode ter listeners internos do tema),
  // criamos um botão novo para WhatsApp e desativamos/ocultamos o original.
  function ensureDrawerWhatsAppButton(){
    var existing = q('#CNW-Drawer-WhatsApp');
    if(existing) return existing;

    var original = findDrawerCheckoutButton();
    if(!original || !original.parentNode) return null;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'CNW-Drawer-WhatsApp';
    // NÃO copiar classes "perigosas" do botão de checkout (muitos temas escutam
    // por classe e redirecionam para /checkout). Mantemos apenas classes seguras.
    var safe = (original.className || '').split(/\s+/).filter(function(c){
      c = String(c||'').trim();
      if(!c) return false;
      if(c === 'cart__checkout-button') return false;
      if(c === 'tpo-btn-checkout') return false;
      if(c === 'cn-hidden') return false;
      return true;
    });
    // Base do tema
    if(safe.indexOf('button') === -1) safe.push('button');
    // Largura total (equivalente ao checkout no drawer)
    if(safe.indexOf('button--full-width') === -1) safe.push('button--full-width');
    btn.className = safe.join(' ');
    btn.style.width = '100%';
    btn.textContent = BTN_TEXT_WA;
    btn.setAttribute('aria-label', 'Falar no WhatsApp para finalizar a encomenda');

    // Inserir logo após o original para manter layout
    original.parentNode.insertBefore(btn, original.nextSibling);
    return btn;
  }

  function removeDrawerWhatsAppButton(){
    var btn = q('#CNW-Drawer-WhatsApp');
    if(btn && btn.parentNode) btn.parentNode.removeChild(btn);
  }

  function applyWhatsAppToDrawerButton(res){
    var btn = findDrawerCheckoutButton();
    if(!btn) return;

    // Guardar estado original para poder restaurar
    if(!btn.dataset.cnOriginalText){
      btn.dataset.cnOriginalText = (btn.textContent || '').trim();
    }
    if(!btn.dataset.cnOriginalType){
      btn.dataset.cnOriginalType = btn.getAttribute('type') || 'submit';
    }

    if(!res || !res.hasEnco){
      // Restaurar para checkout normal
      btn.textContent = btn.dataset.cnOriginalText || btn.textContent;
      btn.setAttribute('type', btn.dataset.cnOriginalType || 'submit');
      btn.removeAttribute('aria-label');
      btn.disabled = false;
      btn.classList.remove('cn-hidden');
      btn.style.display = '';
      removeDrawerWhatsAppButton();
      return;
    }

    // Desativar e ocultar o botão original (evita submit/listeners nativos)
    btn.disabled = true;
    btn.setAttribute('aria-label', 'Checkout desativado para itens por encomenda');
    btn.classList.add('cn-hidden');
    btn.style.display = 'none';

    var waBtn = ensureDrawerWhatsAppButton();
    if(!waBtn) return;

    // Bind click uma vez
    if(waBtn.dataset.cnWaBound === '1') return;
    waBtn.dataset.cnWaBound = '1';

    waBtn.addEventListener('click', function(ev){
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      getCartJSON()
        .then(deriveCartTags)
        .then(function(r){
          if(!r.hasEnco){ window.location.href = '/checkout'; return; }
          if(r.isMixed){
            // carrinho misto mantém fluxo direto para WhatsApp
            var href = buildWhatsHref(r.items, 'mixed');
            try { window.open(href, '_blank', 'noopener'); }
            catch(e){ window.location.href = href; }
            return;
          }
          // só-encomenda: abre o modal novo com formulário
          openEncomendar(r.items);
        })
        .catch(function(){ window.location.href = '/checkout'; });
    }, true);
  }

  // Impedir submit do form do drawer quando houver encomenda
  function patchDrawerSubmitBlock(res){
    var form = q('#CartDrawer-Form');
    if(!form) return;
    if(form.dataset.cnSubmitBound === '1') return;
    form.dataset.cnSubmitBound = '1';
    form.addEventListener('submit', function(ev){
      if(!form || !form.isConnected) return;
      if(!window.__CN_DRAWER_HAS_ENCO) return;
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      // Simula clique no botão WA
      var waBtn = q('#CNW-Drawer-WhatsApp');
      if(waBtn){ waBtn.click(); }
    }, true);
  }

  // Orquestração
  var pending = false;
  function refreshDrawerCTA(){
    if(pending) return;
    pending = true;
    getCartJSON()
      .then(deriveCartTags)
      .then(function(res){
        window.__CN_DRAWER_HAS_ENCO = !!res.hasEnco;
        applyWhatsAppToDrawerButton(res);
        patchDrawerSubmitBlock(res);
      })
      .catch(function(){ window.__CN_DRAWER_HAS_ENCO = false; })
      .finally(function(){ pending = false; });
  }

  // Atualizar ao abrir drawer / após atualizações
  function boot(){
    refreshDrawerCTA();
    // Observer para mudanças no drawer (AJAX cart)
    var drawer = q('cart-drawer') || q('#CartDrawer') || q('.cart-drawer');
    if(drawer && !drawer.dataset.cnObs){
      drawer.dataset.cnObs = '1';
      var mo = new MutationObserver(function(){
        // pequenas mudanças (qty, remoção, etc.)
        refreshDrawerCTA();
      });
      mo.observe(drawer, {subtree:true, childList:true, characterData:false});
    }
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  // Alguns temas disparam eventos custom no drawer
  document.addEventListener('cart:updated', refreshDrawerCTA);
  document.addEventListener('cart-drawer:refresh', refreshDrawerCTA);

  // Garantir que ao fechar/continuar do modal, a CTA do drawer seja recalculada
  document.addEventListener('click', function(e){
    var el = e.target;
    if(!el) return;
    if(el.closest && (el.closest('.cnw-close') || el.closest('.cne-close') || el.id==='cnw-continue' || el.id==='cne-continue')){
      setTimeout(function(){
        closeAnyModal();
        refreshDrawerCTA();
      }, 50);
    }
  }, true);
})();
